'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var includes = function includes(arr, o) {
  return (0, _lodash.isObject)(o) ? JSON.stringify(arr).indexOf(JSON.stringify(o)) > -1 : arr.indexOf(o) > -1;
};

exports.default = includes;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/includes.js